export default {
    'Close menu': 'Menu sluiten',
    'Close submenu': 'Submenu sluiten',
    'Open submenu': 'Submenu openen',
    'Toggle submenu': 'Submenu wisselen'
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/mmenu-js/dist/core/screenreader/translations/nl.js
// module id = 442
// module chunks = 0